import { useEffect, useState } from "react";

// Google Web App URL
const SCRIPT_URL = "https://script.google.com/macros/s/AKfycbwaFCqQV0PG8_LAx3v7exnidBDrqcEVugCQRx5v6eaLwRgA8g_ElfV7hxoFUp1kh-TN/exec";

const field = {
  width: "100%",
  padding: ".7rem 0.8rem",
  borderRadius: "0.7rem",
  border: "1px solid #d9e7ea",
};

const pill = {
  display: "inline-flex",
  alignItems: "center",
  gap: ".45rem",
  padding: ".45rem .7rem",
  borderRadius: "999px",
  border: "1px solid #d9e7ea",
  background: "#fff",
};

const isValidEmail = (email) => {
  // Simple regex for email validation
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export default function JoinModal({ open, onClose }) {
  // Prevent background scroll when modal is open
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
      // 🟢 1. START THE TIMER HERE
      setStartTime(Date.now());
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  const [isSuccess, setIsSuccess] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [age, setAge] = useState("");
  const [location, setLocation] = useState("");
  const [skill, setSkill] = useState("Beginner");
  const [activities, setActivities] = useState([]);
  const [other, setOther] = useState("");
  
  const [referrerData, setReferrerData] = useState({ source: "", medium: "" });
  const [isSubmitting, setIsSubmitting] = useState(false); 
  // 🟢 2. ADD STATE FOR TIMER
  const [startTime, setStartTime] = useState(0);

  // Capture UTM parameters when the component mounts
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setReferrerData({
      source: params.get("utm_source") || "",
      medium: params.get("utm_medium") || ""
    });
  }, []);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  const toggle = (v) =>
    setActivities((xs) => (xs.includes(v) ? xs.filter((x) => x !== v) : [...xs, v]));

  // Connected Submit Function
  const submit = (e) => {
    e.preventDefault();

    // Check empty required fields
    if (!name.trim() || !email.trim() || !age.trim() || !location.trim()) {
      alert("Please fill out all required fields (name, email, age).");
      return;
    }

    // Check for Valid Email Format
    if (!isValidEmail(email)) {
      alert("Please enter a valid email address.");
      return;
    }

    // Age check
    const ageNum = parseInt(age, 10);
    if (isNaN(ageNum) || ageNum < 13 || ageNum > 99) {
      alert("Please enter a valid age (must be between 13 and 99).");
      return;
    }

    if (activities.length === 0 && !other.trim()) {
      alert("Please select at least one activity (or add a custom one).");
      return;
    }

    setIsSubmitting(true); 

    // Create a Form Data object to send to Google
    const formData = new FormData();
    formData.append("timestamp", new Date().toISOString());
    formData.append("name", name);
    formData.append("email", email);
    formData.append("age", age);         
    formData.append("location", location); 
    formData.append("activities", activities.join(", ")); 
    formData.append("other", other);
    formData.append("referrer_source", referrerData.source);
    formData.append("referrer_medium", referrerData.medium);

    // Send to Google Apps Script
    fetch(SCRIPT_URL, { method: "POST", body: formData })
      .then((response) => {
        
        // 🟢 3. CALCULATE TIME & SEND TO GOOGLE
        if (window.gtag) {
          // Calculate seconds (Now - StartTime) / 1000
          const timeTaken = Math.round((Date.now() - startTime) / 1000);
          
          window.gtag('event', 'generate_lead', {
            'event_category': 'Waitlist',
            'event_label': 'New User',
            'value': timeTaken, // This sends the seconds to Google!
            'currency': 'USD'   // Required when using 'value'
          });
        }
        
        setIsSubmitting(false);
        setIsSuccess(true); 
        
        // Clear form
        setName(""); 
        setEmail(""); 
        setAge("");          
        setLocation("");   
        setOther("");        
        setSkill("Beginner");
        setActivities([]);
      })
      .catch((error) => {
        console.error("Error!", error.message);
        alert("Something went wrong. Please try again.");
        setIsSubmitting(false);
      });
  };

  const opts = [
    "Running", "Gym/Weights", "Yoga/Pilates", "Hiking", "Cycling/Biking",
    "Swimming", "CrossFit", "Rock Climbing", "Basketball", "Walking",
    "Football", "Paddle Boarding/Surfing"
  ];

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,.45)",
        display: "grid",
        placeItems: "center",
        padding: "1rem",
        zIndex: 10000,
        overflowY: "auto",
        WebkitOverflowScrolling: "touch",
      }}
      onClick={onClose}
    >
      <div
        role="dialog"
        aria-modal="true"
        style={{
          width: "min(720px, 100%)",
          background: "#fff",
          color: "#0e1a22",
          borderRadius: "18px",
          border: "1px solid #d9e7ea",
          padding: "1.5rem",
          boxShadow: "0 20px 50px rgba(0,0,0,.18)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {isSuccess ? (
          /* SUCCESS STATE UI */
          <div style={{ textAlign: "center", padding: "1rem 0" }}>
            <div
              style={{
                width: "80px",
                height: "80px",
                background: "#afd7c2",
                borderRadius: "50%",
                margin: "0 auto 1.5rem auto",
                display: "grid",
                placeItems: "center",
                color: "#1f5f45",
              }}
            >
              <svg
                width="40"
                height="40"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </div>

            <h2 style={{ margin: "0 0 0.5rem 0", color: "#1f2e36" }}>
              You're on the list!
            </h2>
            <p
              style={{
                margin: "0 0 2rem 0",
                color: "#6b7c85",
                fontSize: "1.1rem",
                lineHeight: "1.5",
              }}
            >
              Thanks for joining <strong>BeFitFriends</strong>.<br />
              Keep an eye on your inbox for your early access invite.
            </p>

            <button
              onClick={() => {
                setIsSuccess(false);
                onClose();
              }}
              style={{
                background: "#86a3be",
                color: "#fff",
                border: "none",
                padding: ".8rem 2rem",
                borderRadius: "10px",
                fontWeight: 600,
                fontSize: "1rem",
                cursor: "pointer",
                boxShadow: "0 4px 12px rgba(134, 163, 190, 0.4)",
              }}
            >
              Awesome!
            </button>
          </div>
        ) : (
          /* ORIGINAL FORM UI */
          <>
            <h3 style={{ marginBottom: ".25rem", color: "#86a3be" }}>
              Join BeFitFriends
            </h3>
            <p style={{ margin: 0, color: "#1f2e36" }}>
              Want to be part of the <strong>first group</strong> using the app?
              Add your details below for early access.
            </p>

            <form onSubmit={submit} style={{ marginTop: "0.9rem" }}>
              {/* Name + Email */}
              <div
                style={{
                  display: "grid",
                  gap: "0.8rem",
                  gridTemplateColumns: "1fr 1fr",
                }}
              >
                <div>
                  <label>Name</label>
                  <input
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                    placeholder="Jane Doe"
                    style={field}
                  />
                </div>
                <div>
                  <label>Email</label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    placeholder="jane@example.com"
                    style={field}
                  />
                </div>
              </div>

              {/* Age + City/State */}
              <div
                style={{
                  display: "grid",
                  gap: "0.8rem",
                  gridTemplateColumns: "1fr 1fr",
                  marginTop: ".9rem",
                }}
              >
                <div>
                  <label>Age</label>
                  <input
                    type="number"
                    min="13"
                    value={age}
                    onChange={(e) => setAge(e.target.value)}
                    required
                    placeholder="25"
                    style={field}
                  />
                </div>
                <div>
                  <label>City, State</label>
                  <input
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                    required
                    placeholder="Boca Raton, FL"
                    style={field}
                  />
                </div>
              </div>

              {/* Activities */}
              <div style={{ marginTop: ".9rem" }}>
                <label>Activities you like</label>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: ".5rem .8rem",
                    marginTop: ".4rem",
                  }}
                >
                  {opts.map((o) => (
                    <label
                      key={o}
                      style={{
                        ...pill,
                        border: activities.includes(o)
                          ? "2px solid #8fbfc2"
                          : pill.border,
                        background: activities.includes(o)
                          ? "#afd7c2"
                          : pill.background,
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={activities.includes(o)}
                        onChange={() => toggle(o)}
                      />
                      {o}
                    </label>
                  ))}
                </div>
              </div>

              {/* Other Activities */}
              <div style={{ marginTop: ".9rem" }}>
                <label>Other activities (optional)</label>
                <input
                  value={other}
                  onChange={(e) => setOther(e.target.value)}
                  placeholder="CrossFit, rowing, dance…"
                  style={field}
                />
              </div>

              {/* Actions */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: ".6rem",
                  marginTop: "1rem",
                }}
              >
                <button
                type="button"
                className="btn"
                onClick={onClose}
                style={{
                  background: "transparent",       // No background color
                  color: "#4a5568",                // Dark grey text (neutral)
                  border: "1px solid #cbd5e0",     // Thin, subtle border
                  padding: ".6rem 1.2rem",
                  borderRadius: "10px",
                  fontWeight: "500",
                  cursor: "pointer",
                  transition: "all 0.2s ease"      // Smooth hover effect
                }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="btn"
                  style={{
                    background: isSubmitting ? "#ccc" : "#86a3be",
                    color: "#fff",
                    border: "none",
                    padding: ".6rem 1.2rem",
                    borderRadius: "10px",
                    fontWeight: 600,
                    cursor: "pointer",
                  }}
                >
                  {isSubmitting ? "Joining..." : "Submit"}
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
}